import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class BreadcrumbCustomer extends Component {

    render() {
        return (
            <div className='cr-page__header'>
                <div className='col-sm-6 breadcrumb-header p-0'>
                    {/* { this.props.icon ? this.props.icon : ''} */}
                    <h1 className='breadcrumb-title'>{this.props.title}</h1>
                </div>
                <div className='col-md-6 com-sm-12  p-0'>
                    <ol className='breadcrumb float-sm-right'>
                        <li className='breadcrumb-item'>
                            <Link to="/">Home</Link>
                        </li>
                        <li className='active breadcrumb-item' aria-current="page">
                            {this.props.page}
                        </li>
                    </ol>
                </div>
            </div>
        );
    }
}
